export enum PlanErrorCode {
  CLINIC_NOT_FOUND = 'CLINIC_NOT_FOUND',
  TREATMENT_NOT_FOUND = 'PROVIDER_TREATMENT_NOT_FOUND',
  PLAN_NOT_REQUESTABLE = 'PLAN_NOT_REQUESTABLE',
  GAIA_PLAN_NOT_FOUND = 'GAIA_PLAN_NOT_FOUND',
  GAIA_PLAN_CREATE_FAILED = 'GAIA_PLAN_CREATE_FAILED',
  PREDICTION_MISSING_PROBS = 'PREDICTION_MISSING_PROBABILITIES',
  PENDING_QUOTE_REQUEST_FOR_THIS_USER_AND_CLINIC_EXIST = 'PENDING_QUOTE_REQUEST_FOR_THIS_USER_AND_CLINIC_EXIST',
  QUOTE_REQUEST_CREATE_FAILED = 'QUOTE_REQUEST_CREATE_FAILED',
  QUOTE_NOT_FOUND = 'QUOTE_NOT_FOUND',
  QUOTE_ALREADY_SENT = 'QUOTE_ALREADY_SENT',
  QUOTE_ALREADY_READY = 'QUOTE_ALREADY_READY',
  QUOTE_NOT_READY = 'QUOTE_NOT_READY',
  QUOTE_MISSING_FERTILITY_PROFILE = 'QUOTE_MISSING_FERTILITY_PROFILE',
  ACCEPTED_QUOTE_EXISTS = 'ACCEPTED_QUOTE_EXISTS',
  QUOTE_ARCHIVED = 'QUOTE_ARCHIVED',
  QUOTE_SOFT_DELETED = 'QUOTE_SOFT_DELETED',
  ACTIVE_QUOTE_EXISTS = 'ACTIVE_QUOTE_EXISTS',
  QUOTE_NOT_SENT = 'QUOTE_NOT_SENT',
  QUOTE_ACCEPTED = 'QUOTE_ACCEPTED',
  QUOTE_REJECTED = 'QUOTE_REJECTED',
  QUOTE_EXPIRED = 'QUOTE_EXPIRED',
  INVALID_QUOTE = 'INVALID_QUOTE',
  INVALID_VARIANT = 'INVALID_VARIANT',
  OVERLAPPING_ESTIMATE_PREMIUM_EXISTS = 'OVERLAPPING_ESTIMATE_PREMIUM_EXISTS',
  OVERLAPPING_ESTIMATE_FIXED_PRICE_EXISTS = 'OVERLAPPING_ESTIMATE_FIXED_PRICE_EXISTS',
  EMAIL_NEEDED_FOR_LEAD = 'EMAIL_NEEDED_FOR_LEAD',
  COSTBREAKDOWN_OR_FRESHROUNDCOST_AND_FROZENROUNDCOST_REQUIRED = 'COSTBREAKDOWN_OR_FRESHROUNDCOST_AND_FROZENROUNDCOST_REQUIRED',
  USER_HAS_NO_ACTIVE_ACCEPTED_NOA_QUOTE = 'USER_HAS_NO_ACTIVE_ACCEPTED_NOA_QUOTE',
  USER_HAS_NO_ACTIVE_ACCEPTED_LETO_QUOTE = 'USER_HAS_NO_ACTIVE_ACCEPTED_LETO_QUOTE',
  USER_HAS_MULTIPLE_ACCEPTED_QUOTES = 'USER_HAS_MULTIPLE_ACCEPTED_QUOTES',
  QUOTE_MISSING_MAX_FINANCED_LIABILITY = 'QUOTE_MISSING_MAX_FINANCED_LIABILITY',
  RELATED_REQUEST_FULFILLED_BUT_NO_QUOTE = 'RELATED_REQUEST_FULFILLED_BUT_NO_QUOTE',
  CANNOT_REJECT_WITHOUT_PATHWAY = 'CANNOT_REJECT_WITHOUT_PATHWAY',
  REJECTION_REASON_REQUIRED = 'REJECTION_REASON_REQUIRED',
  QUOTE_REQUEST_ALREADY_REJECTED = 'QUOTE_REQUEST_ALREADY_REJECTED',
  QUOTE_REQUEST_ALREADY_ARCHIVED = 'QUOTE_REQUEST_ALREADY_ARCHIVED',
  QUOTE_REQUEST_ALREADY_FULFILLED = 'QUOTE_REQUEST_ALREADY_FULFILLED',
  INVALID_REJECTION_REASONS = 'INVALID_REJECTION_REASONS',
  QUOTE_MISSING_INTEREST_RATE = 'QUOTE_MISSING_INTEREST_RATE',
  INVALID_ROUNDS_COVERED = 'INVALID_ROUNDS_COVERED',
  TREATMENT_PATHWAY_NOT_FOUND = 'TREATMENT_PATHWAY_NOT_FOUND',
  NULL_RELATIVE_PREMIUM = 'PLAN HAS NULL RELATIVE PREMIUM',
  MAX_PAYMENT_PERIOD_YEARS_NOT_WHOLE_NUMBER = 'MAX_PAYMENT_PERIOD_YEARS_NOT_WHOLE_NUMBER',
}
